module.exports = __webpack_public_path__ + "assets/media/videos.1c473043.mp4";